
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/outdoorsy-group",
      function () {
        return require("private-next-pages/about/outdoorsy-group/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/outdoorsy-group"])
      });
    }
  